import { StatusBadge, STATUS_BADGES } from "@/shared/components/StatusBadge";
import { type AgentThreadStatus } from "@/shared/domain/agentThread";

interface ThreadStatusBadgeProps {
  status: AgentThreadStatus;
}

/**
 * A thread's status as a badge. While Roboto is working on it, its loader
 * icon spins; the label already says it is working, so nothing extra is
 * announced.
 */
export function ThreadStatusBadge({ status }: ThreadStatusBadgeProps) {
  return <StatusBadge status={STATUS_BADGES.agentThread[status]} />;
}
